// extracted by mini-css-extract-plugin
export var modal = "_d8-0";